import React from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import BuildRoundedIcon from "@mui/icons-material/BuildRounded";
import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";
import RouterRoundedIcon from "@mui/icons-material/RouterRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import { motion } from "framer-motion";
import drImage from "../../static/media/StrategicAllies/dr_strategic.webp";
import drLogo from "../../static/media/StrategicAllies/logo_dr.webp";

const MotionBox = motion(Box);

const services = [
  {
    label: "Diseño de páginas web",
    icon: <LanguageRoundedIcon sx={{ fontSize: 18 }} />,
  },
  {
    label: "Facturación e inventario empresarial",
    icon: <Inventory2RoundedIcon sx={{ fontSize: 18 }} />,
  },
  {
    label: "Soporte técnico y mantenimiento",
    icon: <BuildRoundedIcon sx={{ fontSize: 18 }} />,
  },
  {
    label: "Cámaras de seguridad, redes y conectividad",
    icon: <SecurityRoundedIcon sx={{ fontSize: 18 }} />,
  },
];

export default function DrStrategic() {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        py: { xs: 4.5, md: 7.5 },
        bgcolor: "#ffffff",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: { xs: "92%", md: "90%" },
          maxWidth: 1400,
          mx: "auto",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: { xs: -100, md: -120 },
            right: { xs: -90, md: -110 },
            width: { xs: 220, md: 320 },
            height: { xs: 220, md: 320 },
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(229,9,20,0.14) 0%, rgba(229,9,20,0.05) 42%, rgba(229,9,20,0) 72%)",
            filter: "blur(10px)",
            pointerEvents: "none",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            left: { xs: -110, md: -120 },
            bottom: { xs: -110, md: -120 },
            width: { xs: 230, md: 320 },
            height: { xs: 230, md: 320 },
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(17,17,17,0.10) 0%, rgba(17,17,17,0.04) 42%, rgba(17,17,17,0) 72%)",
            filter: "blur(12px)",
            pointerEvents: "none",
          }}
        />

        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "minmax(0,1.02fr) minmax(0,0.98fr)",
            },
            gap: { xs: 2.8, md: 2.8, lg: 3.2 },
            alignItems: "center",
          }}
        >
          <MotionBox
            initial={{ opacity: 0, x: -34 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              minWidth: 0,
              py: { xs: 0.5, md: 1.1 },
              pr: { xs: 0, md: 0.8, lg: 1.4 },
              order: { xs: 1, md: 1 },
            }}
          >
            <Box
              component="img"
              src={drLogo}
              alt="D&R Soluciones Informáticas"
              sx={{
                width: "100%",
                maxWidth: { xs: 180, md: 270 },
                height: "auto",
                display: "block",
                mb: 1.7,
                mx: { xs: "auto", md: 0 },
              }}
            />

            <Typography
              sx={{
                color: "#e50914",
                fontWeight: 800,
                fontSize: { xs: 15.3, md: 16.2 },
                lineHeight: 1.65,
                mb: 1.35,
                maxWidth: { xs: "100%", md: "58ch" },
              }}
            >
              D&R Soluciones Informáticas ofrece un 15% de descuento a los
              miembros de NovaXFit en sus principales servicios tecnológicos.
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: 14.8, md: 15.8 },
                color: "rgba(0,0,0,0.66)",
                fontWeight: 600,
                lineHeight: 1.78,
                mb: 2.2,
                maxWidth: { xs: "100%", md: "59ch" },
              }}
            >
              Beneficio válido en servicios digitales empresariales, soporte
              técnico y mantenimiento, soluciones de seguridad y conectividad.
            </Typography>

            <Box
              sx={{
                borderRadius: "22px",
                p: { xs: 1.5, md: 1.75 },
                mb: 2.25,
                background:
                  "linear-gradient(180deg, rgba(255,255,255,0.92) 0%, rgba(255,247,247,0.98) 100%)",
                border: "1px solid rgba(229,9,20,0.10)",
                boxShadow: "0 14px 32px rgba(0,0,0,0.04)",
                maxWidth: { xs: "100%", md: 640 },
              }}
            >
              <Typography
                sx={{
                  color: "#e50914",
                  fontWeight: 800,
                  fontSize: { xs: 14.6, md: 15.1 },
                  lineHeight: 1.6,
                  mb: 1.2,
                }}
              >
                Beneficio exclusivo NovaXFit
              </Typography>

              <Typography
                sx={{
                  fontSize: 14.1,
                  fontWeight: 650,
                  color: "rgba(0,0,0,0.66)",
                  lineHeight: 1.6,
                  mb: 1.4,
                }}
              >
                Presenta tu membresía activa y accede a descuento en servicios
                tecnológicos seleccionados.
              </Typography>

              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: 15.2,
                  color: "#111111",
                  mb: 1.1,
                }}
              >
                Términos y condiciones
              </Typography>

              <Stack spacing={0.95}>
                {[
                  "Aplica únicamente para miembros activos de NovaXFit.",
                  "El descuento es válido solo en servicios.",
                  "No aplica en productos, repuestos, licencias ni promociones especiales.",
                  "El beneficio está sujeto a validación previa de membresía activa.",
                ].map((item) => (
                  <Stack
                    key={item}
                    direction="row"
                    spacing={1}
                    alignItems="flex-start"
                  >
                    <Box
                      sx={{
                        width: 7,
                        height: 7,
                        borderRadius: "50%",
                        bgcolor: "#e50914",
                        mt: "8px",
                        flexShrink: 0,
                        boxShadow: "0 0 0 5px rgba(229,9,20,0.08)",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: 14.1,
                        fontWeight: 650,
                        color: "rgba(0,0,0,0.66)",
                        lineHeight: 1.6,
                      }}
                    >
                      {item}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Box>

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1.25}
              sx={{ alignItems: { xs: "stretch", sm: "center" } }}
            >
              <Button
                component="a"
                href="https://drsolucionesinformaticas.com/"
                target="_blank"
                rel="noopener noreferrer"
                endIcon={<ArrowOutwardRoundedIcon />}
                sx={{
                  textTransform: "none",
                  fontWeight: 900,
                  borderRadius: "15px",
                  px: 3,
                  py: 1.35,
                  fontSize: 14.6,
                  color: "#ffffff",
                  background:
                    "linear-gradient(135deg,#5f0008 0%,#a80d19 38%,#df2632 72%,#161616 100%)",
                  boxShadow: "0 16px 36px rgba(229,9,20,0.20)",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg,#71000a 0%,#bb101c 38%,#f1333f 72%,#111111 100%)",
                    boxShadow: "0 18px 38px rgba(229,9,20,0.25)",
                  },
                }}
              >
                Visitar sitio web
              </Button>
              <Button
                component="a"
                href="https://wa.me/593984493776?text=Hola,%20quiero%20solicitar%20más%20información"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  textTransform: "none",
                  fontWeight: 900,
                  borderRadius: "15px",
                  px: 3,
                  py: 1.35,
                  fontSize: 14.6,
                  color: "#111111",
                  bgcolor: "#ffffff",
                  border: "1px solid rgba(0,0,0,0.12)",
                  boxShadow: "0 10px 24px rgba(0,0,0,0.04)",
                  "&:hover": {
                    bgcolor: "#fff8f8",
                    borderColor: "rgba(229,9,20,0.24)",
                  },
                }}
              >
                0984 493 776
              </Button>
            </Stack>
          </MotionBox>

          <MotionBox
            initial={{ opacity: 0, x: 34 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.78, ease: [0.22, 1, 0.36, 1] }}
            sx={{
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              order: { xs: 2, md: 2 },
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: { xs: "70%", md: "85%" },
                minHeight: { xs: 380, sm: 480, md: 650 },
                borderRadius: { xs: "28px", md: "32px" },
                overflow: "hidden",
                boxShadow: "0 24px 60px rgba(0,0,0,0.18)",
                background: "#111111",
              }}
            >
              <Box
                component="img"
                src={drImage}
                alt="Servicios tecnológicos D&R Soluciones Informáticas"
                sx={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  transform: { xs: "scale(1.04)", md: "scale(1.01)" },
                }}
              />

              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background: {
                    xs: "linear-gradient(180deg, rgba(0,0,0,0.14) 0%, rgba(0,0,0,0.24) 58%, rgba(0,0,0,0.50) 100%)",
                    md: "linear-gradient(180deg, rgba(0,0,0,0.18) 0%, rgba(0,0,0,0.16) 22%, rgba(0,0,0,0.48) 70%, rgba(0,0,0,0.82) 100%)",
                  },
                }}
              />

              <MotionBox
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.62, delay: 0.18 }}
                sx={{
                  position: "absolute",
                  left: 18,
                  right: 18,
                  bottom: 18,
                  zIndex: 3,
                  borderRadius: "24px",
                  p: 1.35,
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.09) 100%)",
                  border: "1px solid rgba(255,255,255,0.16)",
                  backdropFilter: "blur(12px)",
                  boxShadow: "0 18px 34px rgba(0,0,0,0.14)",
                  display: { xs: "none", md: "block" },
                }}
              >
                <Typography
                  sx={{
                    color: "#ffffff",
                    fontWeight: 850,
                    fontSize: 14.6,
                    mb: 1.15,
                    letterSpacing: -0.2,
                  }}
                >
                  Servicios incluidos en el beneficio
                </Typography>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      sm: "1fr 1fr",
                    },
                    gap: 1,
                  }}
                >
                  {services.map((service, index) => (
                    <MotionBox
                      key={service.label}
                      initial={{ opacity: 0, y: 14 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{
                        duration: 0.42,
                        delay: 0.24 + index * 0.08,
                      }}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        minWidth: 0,
                        px: 1,
                        py: 0.95,
                        borderRadius: "16px",
                        background: "rgba(255,255,255,0.10)",
                        border: "1px solid rgba(255,255,255,0.10)",
                      }}
                    >
                      <Box
                        sx={{
                          width: 36,
                          height: 36,
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          color: "#ffffff",
                          background:
                            "linear-gradient(135deg,#5f0008 0%,#a80d19 48%,#df2632 100%)",
                          boxShadow: "0 8px 18px rgba(229,9,20,0.22)",
                        }}
                      >
                        {service.icon}
                      </Box>

                      <Typography
                        sx={{
                          color: "#ffffff",
                          fontWeight: 700,
                          fontSize: 13.4,
                          lineHeight: 1.35,
                          letterSpacing: -0.15,
                        }}
                      >
                        {service.label}
                      </Typography>
                    </MotionBox>
                  ))}
                </Box>
              </MotionBox>
            </Box>

            <Box
              sx={{
                width: "100%",
                display: { xs: "block", md: "none" },
                mt: 1.6,
              }}
            >
              <Typography
                sx={{
                  color: "#111111",
                  fontWeight: 900,
                  fontSize: 16,
                  mb: 1.2,
                  letterSpacing: -0.25,
                }}
              >
                Servicios incluidos en el beneficio
              </Typography>

              <Stack spacing={1}>
                {services.map((service) => (
                  <Box
                    key={service.label}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      px: 1.1,
                      py: 1,
                      borderRadius: "16px",
                      background:
                        "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(252,245,246,0.94) 100%)",
                      border: "1px solid rgba(229,9,20,0.10)",
                      boxShadow: "0 10px 22px rgba(0,0,0,0.04)",
                    }}
                  >
                    <Box
                      sx={{
                        width: 38,
                        height: 38,
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        color: "#ffffff",
                        background:
                          "linear-gradient(135deg,#5f0008 0%,#a80d19 48%,#df2632 100%)",
                        boxShadow: "0 8px 18px rgba(229,9,20,0.18)",
                      }}
                    >
                      {service.icon}
                    </Box>

                    <Typography
                      sx={{
                        color: "#111111",
                        fontWeight: 800,
                        fontSize: 13.6,
                        lineHeight: 1.35,
                        letterSpacing: -0.15,
                      }}
                    >
                      {service.label}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            </Box>
          </MotionBox>
        </Box>
      </Box>
    </Box>
  );
}